<script>
import SvgIcon from '@g/components/SvgIcon.vue'
import { ensureSiteIcons } from './siteAssets'

// 仅官网替换全局注册，会员 SPA 沿用原图标初始化方式。
export default {
  extends: SvgIcon,
  mounted () {
    ensureSiteIcons().catch(() => {})
  },
}
</script>
